import { FaAward, FaLeaf, FaUsers, FaIndustry, FaFlask, FaTruck } from "react-icons/fa6";

const aboutUsData = {
  hero_section: {
    title: "About Zenvia Foods Private Limited",
    description: "From Farm to Fork, With Care • Quality You Can Trust",
    src: "videos/aboutus.webm",
  },
  company_story: {
    title: "Who We Are",
    description: "Zenvia Foods Private Limited is a modern food processing company dedicated to reducing post-harvest losses, enhancing farmer incomes, and delivering natural, healthy fruit-based products to domestic and international markets. Based in Theni, Tamil Nadu – the Fruit Basket of South India, our state-of-the-art facility is equipped with advanced processing, cold chain, and quality control infrastructure to ensure consistent supply, safety, and traceability.",
  },
  mission_vision: {
    mission: "To bridge the farm-to-fork gap by creating sustainable value chains for fruits and vegetables, while meeting the rising demand for natural and convenient food products.",
    vision: "To become a leading global supplier of fruit pulps and frozen produce from India, recognized for quality, reliability, and sustainability.",
  },
  values: [
    {
      icon: <FaLeaf style={{ fontSize: "32px" }} />,
      title: "Farm-Fresh Sourcing",
      description: "Direct procurement from farmers and FPOs ensures consistent quality and fair pricing for agricultural communities.",
    },
    {
      icon: <FaAward style={{ fontSize: "32px" }} />,
      title: "Quality Assurance",
      description: "HACCP, FSSAI, and export-compliant laboratory testing with full traceability from farm to end-customer.",
    },
    {
      icon: <FaIndustry style={{ fontSize: "32px" }} />,
      title: "Modern Processing",
      description: "State-of-the-art facility with advanced cold chain and quality control infrastructure.",
    },
    {
      icon: <FaUsers style={{ fontSize: "32px" }} />,
      title: "Sustainability",
      description: "Waste utilization, renewable energy adoption, and farmer welfare initiatives at the core of our operations.",
    },
    {
      icon: <FaFlask style={{ fontSize: "32px" }} />,
      title: "Global Standards",
      description: "Products comply with FSSAI, Codex, and international export standards for global market reach.",
    },
    {
      icon: <FaTruck style={{ fontSize: "32px" }} />,
      title: "Cold Chain Excellence",
      description: "Blast freezers, IQF tunnels, and –20°C storage with proximity to major ports for reliable delivery.",
    },
  ],
  journey: [
    {
      year: "2017",
      title: "Foundation",
      description: "Zenvia Foods Private Limited was established with a vision to bridge the farm-to-fork gap in Tamil Nadu.",
    },
  {
      year: "2017",
      title: "Facility Setup",
      description: "Set up state-of-the-art processing facility with modern infrastructure.",
    },
    {
      year: "2017",
      title: "Quality Certifications",
      description: "Achieved HACCP, FSSAI certifications and established export-compliant quality systems.",
    },
    {
      year: "2021",
      title: "Product Diversification",
      description: "Expanded product range to include IQF frozen fruits, vegetables, and custom mixed fruit pulps.",
    },
    {
      year: "2021",
      title: "Global Expansion",
      description: "Established export partnerships across Middle East, Europe, and North America markets.",
    },
    {
      year: "2023",
      title: "Sustainable Growth",
      description: "Continuing innovation in processing technology while strengthening farmer partnerships.",
    },
  ],
};

export default aboutUsData;
